import { ResolveFn } from '@angular/router';
import { CasiStoryEstimate } from '../models/models.lib';
import { inject } from '@angular/core';
import { UserStoryEstimateService } from '../tracker/user-story-estimate.service';

export const casiStoryEstimatesResolver: ResolveFn<CasiStoryEstimate> = (route, state) => {
  return inject(UserStoryEstimateService).get();
};
